exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".my-page-check{text-align:center}.mypage-check-title{font-family:NanumBarunGothicOTF;font-size:20px;font-weight:400;margin-bottom:30px}.mypage-check-input{width:416px;height:62px;border-radius:3px;border:1px solid #e2e2e2;background-color:#fff;font-family:NanumBarunGothicUltraLightOTF;font-size:16px;font-weight:200;line-height:62px;padding:10px 20px}.mypage-check-button{width:416px;height:64px;border-radius:3px;box-shadow:0 3px 10px 0 rgba(75,116,255,.6);background-color:#4b74ff;font-family:NanumBarunGothicOTF;font-size:20px;line-height:64px;text-align:center;color:#fff;border:none;margin-top:30px;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5285fabd","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/MypageManager/MypageCheck.vue
// module id = 304
// module chunks = 0